import { clearHqToken } from "@/hq/hq-auth";
import { HqSDK } from "@/@sdk/hq/hq-sdk";
import { Button } from "@/components/ui/button";
import { NavLink, Outlet, useNavigate } from "react-router";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/hq/organizations", label: "Organizations" },
  { to: "/hq/users", label: "Users" },
  { to: "/hq/migrations", label: "Migrations" },
];

export function HqLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearHqToken();
    HqSDK.configure({ token: "" });
    navigate("/hq/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-4">
          <div className="flex items-center gap-6">
            <div>
              <h1 className="text-lg font-semibold">TA Desk HQ</h1>
              <p className="text-xs text-muted-foreground">Internal admin console</p>
            </div>
            <nav className="flex items-center gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    cn(
                      "rounded-md px-3 py-2 text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary text-primary-foreground"
                        : "text-muted-foreground hover:bg-muted hover:text-foreground"
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <Button variant="outline" size="sm" onClick={handleLogout}>
            Log out
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
